import { render, staticRenderFns } from "./ResellerUserActions.vue?vue&type=template&id=25ea1e7d&"
import script from "./ResellerUserActions.vue?vue&type=script&lang=js&"
export * from "./ResellerUserActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports